import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Text, Card } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';

interface CaseData {
  title: string;
  summary: string;
}

const knownCases: Record<string, CaseData> = {
  'vik-2024-033': {
    title: 'VIK-2024-033 — AeroConnect Airlines',
    summary:
      '$4.0M VIK allocation. $2.4M drawn. 7 days remaining. Contract prohibits rollover. Nolij forecasts $1.2M forfeiture risk without intervention.',
  },
};

const CaseDetailPage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const caseData = caseId ? knownCases[caseId] : undefined;

  return (
    <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#fafafa' }}>
      {/* Header with back button */}
      <div
        style={{
          padding: '16px 24px',
          backgroundColor: 'white',
          borderBottom: '1px solid #e1dfdd',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Button
          appearance="subtle"
          icon={<ArrowLeftRegular />}
          onClick={handleBack}
        >
          Back
        </Button>
        <Text size={500} weight="semibold" style={{ color: '#242424' }}>
          {caseData ? caseData.title : caseId ? caseId.toUpperCase() : 'Case Detail'}
        </Text>
      </div>

      {/* Content */}
      <div style={{ padding: '24px', maxWidth: '800px' }}>
        {caseData ? (
          <Card style={{ padding: '24px' }}>
            <Text as="h1" size={700} weight="bold" block>
              {caseData.title}
            </Text>
            <Text
              size={400}
              style={{ marginTop: '16px', color: '#616161', lineHeight: '1.6' }}
              block
            >
              {caseData.summary}
            </Text>
          </Card>
        ) : caseId ? (
          <Card style={{ padding: '24px' }}>
            <Text as="h1" size={700} weight="bold" block>
              {caseId.toUpperCase()}
            </Text>
            <Text
              size={400}
              style={{ marginTop: '16px', color: '#616161' }}
              block
            >
              Case detail placeholder. Full case information will be available when the backend is connected.
            </Text>
          </Card>
        ) : (
          <Card style={{ padding: '24px' }}>
            <Text size={400} style={{ color: '#616161' }} block>
              Case not found. Please navigate back and select a valid case.
            </Text>
          </Card>
        )}
      </div>
    </div>
  );
};

export default CaseDetailPage;
